import { useLocation, NavLink } from 'react-router-dom';
import './breadcrumbs.css';

function Breadcrumbs({ routes }) {
    const location = useLocation();

    return (
        <>
            <nav className='breadcrumb'>
                {routes.map((route, ind) => {
                    const isLast = ind === routes.length - 1;
                    return isLast ? (
                        <span key={route.path} className='ms-2 notActive'>
                            {route.breadcrumb}
                        </span>
                    ) : (
                        <NavLink
                            key={route.path}
                            to={route.path}
                            className={route.path === location.pathname ? 'ms-2 notActive' : 'active'}>
                            {`${route.breadcrumb} > `}
                        </NavLink>
                    );
                })}
            </nav>
        </>
    );
}

export default Breadcrumbs;
